'use client'

import { useCallback, useEffect, useRef } from 'react'
import { Dialog } from '@vinted/web-ui'

import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ReturnShipmentOrderModel } from '@marketplace-web/complaints/complaints-data'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import {
  CheckoutOrderTypeMap,
  ExtraServiceOrderType,
  viewSingleCheckoutEvent,
} from '@marketplace-web/checkout/checkout-data'
import { useNavigateToCheckout } from '@marketplace-web/checkout/checkout-feature'

type Props = {
  returnShipmentOrder: ReturnShipmentOrderModel | undefined
  onErrorDialogOpen: () => void
}

const ReturnShipmentCheckout = ({ returnShipmentOrder, onErrorDialogOpen }: Props) => {
  const { track } = useTracking()
  const { navigateToCheckout } = useNavigateToCheckout()

  const onErrorDialogOpenRef = useRef(onErrorDialogOpen)
  onErrorDialogOpenRef.current = onErrorDialogOpen

  const orderId = Number(returnShipmentOrder?.id)
  const orderType = CheckoutOrderTypeMap[ExtraServiceOrderType.ReturnLabel]

  const fetchCheckout = useCallback(async () => {
    if (!orderId) return

    track(
      viewSingleCheckoutEvent({
        checkoutId: null,
        orderType,
        orderId: orderId.toString(),
      }),
    )

    const isError = await navigateToCheckout(orderId, orderType)

    if (isError) {
      onErrorDialogOpenRef.current()
    }
  }, [navigateToCheckout, orderId, orderType, track])

  useEffect(() => {
    if (!orderId) return

    fetchCheckout()
  }, [fetchCheckout, orderId, track])

  return (
    <Dialog show>
      <ContentLoader testId="return-shipment-checkout-loader" />
    </Dialog>
  )
}

export default ReturnShipmentCheckout
